import React, {Suspense} from 'react';
import {connect} from 'react-redux';
import {Switch, Route, Redirect} from 'react-router-dom';
import {routes, SMCPaths} from '../../../conf/Routes';
import {isEmptyPortalSelector} from '../../../store/selectors/user.selectors';
import SMCPageLoading from '../../core/pageComponents/SMCPageLoading';

const SMPMainBody = ({
    isEmptyPortal
}) => {
    return (
        <Suspense fallback={<SMCPageLoading />}>
            <Switch>
                {
                    routes.map(route => {
                        // If on empty domain, only expose routes that can be shown on empty domain
                        if (isEmptyPortal && !route.showOnEmptyDomain) {
                            return null;
                        }
                        return <Route exact path={route.path} component={route.component} key={route.path} />;
                    })
                }
                {
                    isEmptyPortal && (
                        <Redirect to={SMCPaths.systemSettings} />
                    )
                }
                {
                    !isEmptyPortal && (
                        <Redirect to={SMCPaths.home} />
                    )
                }
            </Switch>
        </Suspense>
    );
}


const mapStateToProps = state => ({
    isEmptyPortal: isEmptyPortalSelector(state),
    key: state.router.location.key // Keep this if wishing to reload body components on every link click instead of on every link change
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(SMPMainBody);